import {
  CardBody,
  CardTitle,
  FormGroup,
  FormText,
  Input,
  Label,
} from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPeopleGroup } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";
import { LivePositionMarker } from "../../../live/LivePositionMarker";
import { DeviceInfo } from "../../../device/DeviceInfoContext";
import OwnNavigationDisabledWarning from "./../../OwnNavigationDisabledWarning";
import { useCrewsQuery } from "../../../crew/useCrewsQuery";
import { CyLivePosition } from "./CyLivePosition";

interface Props {
  deviceInfo: DeviceInfo;
  devicesInPlaylist: readonly DeviceInfo[];
  listOfFollowedDevices: string[];
  setListOfFollowedDevices: (value: (prevState: string[]) => string[]) => void;
  currentCrewIdentifier: string;
}

export function OtherActiveDevices(props: Props) {
  const { t } = useTranslation();

  const { crews } = useCrewsQuery();

  const currentCrew = crews?.find(
    (i) => i.identifier === props.currentCrewIdentifier,
  );

  return (
    <CardBody data-cy={CyLivePosition.OtherDevices}>
      <CardTitle>
        <FontAwesomeIcon icon={faPeopleGroup} />{" "}
        {t("carousel.live.otherDevicesTitle")}{" "}
        {currentCrew && `'${currentCrew.title}'`}
      </CardTitle>
      <FormText>{t("carousel.live.otherDevicesDesc")}</FormText>
      {props.devicesInPlaylist.map((info: DeviceInfo) => (
        <div key={info.deviceIdentifier}>
          <FormGroup switch>
            <Input
              id={"switch-" + info.deviceIdentifier}
              type="switch"
              disabled={
                info.deviceIdentifier === props.deviceInfo.deviceIdentifier
              }
              checked={props.listOfFollowedDevices.includes(
                info.deviceIdentifier,
              )}
              onChange={() => {
                props.setListOfFollowedDevices((old) =>
                  old.includes(info.deviceIdentifier)
                    ? old.filter((i) => i !== info.deviceIdentifier)
                    : [...old, info.deviceIdentifier],
                );
              }}
            />

            <Label for={"switch-" + info.deviceIdentifier}>
              {info.deviceReadableName}
            </Label>
            <LivePositionMarker
              color={info.deviceColor}
              deviceIdentifier={info.deviceIdentifier}
              className={"ms-2"}
            />
          </FormGroup>
        </div>
      ))}
      {props.listOfFollowedDevices.length > 0 && (
        <OwnNavigationDisabledWarning />
      )}
    </CardBody>
  );
}
